import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { fetchFarmerDetail, fetchLoadUnload } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import TripItemEntry from "./TripItemEntry";

class DriverMaster extends Component {
  state = {
    formData: {
      bint_srno: "",
      txtfarmername: "",
      name: "",
    },
    columns: [
      {
        accessorKey: "bint_srno",
        header: "Sr no.",
      },
      {
        accessorKey: "vac_farmername",
        header: "નામ",
      },
    ],
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,
    dataLoadStatus: true,
    ARD: null,
  };

  componentDidMount() {
    document.title = "RA : Farmer Entry";
    this.props.setActiveMenu("FarmerEntry");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };
  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleARDonActionClick_Delete = (row) => {
    const bint_srno = row.getValue("bint_srno"),
      Farmer = row.getValue("vac_farmername");
    this.DeleteData(bint_srno, Farmer);
  };

  DeleteData = (bint_srno, Farmer) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Farmer Name : " + Farmer + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteFarmer(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteFarmer = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteFarmer",
      bint_acid: localStorage.getItem("acid"),
      bint_srno: bint_srno,
      // bol_list: true,
    };
    fetchFarmerDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.PlaeList && res.data.PlaeList.length > 0) {
            rows = res.data.PlaeList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.onFormLoad();
              this.clearInfo();
            }
          );
          document.getElementById("txtfarmername").focus();
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          maxWidthClass={"xl"}
          labelDisagree="Close"
          // New : Sales Item Entry'
          alertMessage={<TripItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadFarmer",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchFarmerDetail(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          if (res.data.FarmerList && res.data.FarmerList.length > 0) {
            rows = res.data.FarmerList;
            rowsCount = rows.length;
          }
          this.setState({
            dataLoadStatus,
            rows,
            rowsCount,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtfarmername").focus();
  };
  clearInfo = () => {
    let bint_srno = "",
      txtfarmername = "";
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          txtfarmername,
        },
      },
      () => {
        document.getElementById("txtfarmername").focus();
      }
    );
  };

  handleARDonActionClick_Edit = (row) => {
    console.log("row", row);
    // console.log('row.original["bint_srno"]', row.original["bint_srno"]);
    const bint_srno = row.getValue("bint_srno"),
      txtfarmername = row.getValue("vac_farmername");
    // const rows2 = row.original.CheckToDoList;
    // console.log("rows2", rows2);
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtfarmername,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txtfarmername").focus();
  };

  SaveFarmer = () => {
    if (this.validatFarmerMaster()) {
      let dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "SaveFarmer",
          bint_acid: localStorage.getItem("acid"),
          bint_srno: this.state.formData.bint_srno,
          vac_farmername: this.state.formData.txtfarmername,
        };
        fetchFarmerDetail(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              dataLoadStatus = true;
              let rows = [],
                rowsCount = 0;
              if (res.data.FarmerList && res.data.FarmerList.length > 0) {
                rows = res.data.FarmerList;
                rowsCount = rows.length;
              }
              this.setState({
                dataLoadStatus,
                rows,
                rowsCount,
              });
              this.clearInfo();
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in Save FarmerMaster.", error);
          });
      });
    }
  };

  validatFarmerMaster = () => {
    let result = false;
    if (this.state.formData.txtfarmername.length <= 0) {
      this.props.toastErrorMsg("Enter Person Name", "txtfarmername");
    } else {
      result = true;
    }
    return result;
  };
  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Farmar Master</b>
          </label>
        </Grid>
        <Grid
          container
          direction="column"
          spacing={2}
          marginTop={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            container
            direction="row"
            spacing={2}
            marginTop={0}
            alignItems="flex-start"
            justifyContent="center"
          >
            <Grid item>
              <CtTxt
                id="txtfarmername"
                value={this.state.formData.txtfarmername}
                handleOnChange={this.handleOnChange}
                label="નામ*"
                width={250}
                maxLength={100}
                onKeyDown={this.props.onKeyDown}
                defaultAction={this.SaveFarmer}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="frlx-start"
            spacing={2}
            marginTop={1}
          >
            <Grid item>
              <CtBtn label="Save" onClick={this.SaveFarmer} />
            </Grid>
            <Grid item>
              <CtBtn label="New" onClick={this.clearInfo} />
            </Grid>
            <Grid item>
              <CtBtn
                label="Delete"
                onClick={() => {
                  this.DeleteData(
                    this.state.formData.bint_srno,
                    this.state.formData.txtfarmername
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          <MaterialTable
            rowsdata={this.state.rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            onEditAction={this.handleARDonActionClick_Edit}
            onDeleteAction={this.handleARDonActionClick_Delete}
            showColumnFilters={false}
            actionColSize={15}
            hideColIdList={["bint_srno"]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(DriverMaster))));
